import { datadogLogs } from '@datadog/browser-logs';
import { getErrorMessage } from '@/utils/error';
import Firebase from '@/lib/firebase';
import { __DEV__, SERVICE_NAME } from '@/constants/env';

export const loggerInit = () => {
  try {
    datadogLogs.init({
      clientToken: 'pub556ec53ef1a5dfd709c73727f0eab5f5',
      service: SERVICE_NAME,
      env: process.env.NODE_ENV,
      forwardErrorsToLogs: !__DEV__,
      sampleRate: 100,
      beforeSend: log => {
        if (__DEV__) {
          console.log('[log]', log);
          return false;
        }
      }
    });
    Firebase.logEvent('web_init', generateMessageContext({}));
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const getPageName = (url: string) => {
  const splitCurrentUrls = url.split('/');
  splitCurrentUrls.shift();
  return `web_pharmacy_${splitCurrentUrls.join('_')}`;
};

const generateMessageContext = (
  messageContext: Record<string, any>
): Record<string, any> => {
  if (!window) return messageContext;

  const customDeviceInfo = {
    screenWidth: window.screen.width,
    screenHeight: window.screen.height,
    pageWidth: document.body.scrollWidth,
    pageHeight: document.body.scrollHeight,
    windowWidth: window.innerWidth,
    windowHeight: window.innerHeight
  };
  return { ...messageContext, ...customDeviceInfo };
};

export const reportLog = (
  message: string,
  messageContext: Record<string, any>
) => {
  try {
    datadogLogs.logger.info(message, messageContext);
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const reportWarn = (
  message: string,
  messageContext: Record<string, any>
) => {
  try {
    datadogLogs.logger.warn(message, messageContext);
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const reportError = (
  message: string,
  messageContext: Record<string, any>
) => {
  try {
    datadogLogs.logger.error(message, messageContext);
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const reportDebug = (
  message: string,
  messageContext: Record<string, any>
) => {
  try {
    datadogLogs.logger.debug(message, messageContext);
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};
